function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function clearCookie(cname) {
	let c = getCookie(cname);
	if (c) {
		var mydate = new Date();
		mydate.setTime(mydate.getTime() - 1);
		document.cookie = cname + "=; expires=" + mydate.toGMTString(); 
	}
}
function hasCookie(cname) {
	let c = getCookie(cname);
	return c !== ""
}

function s4() {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
}

function guid() {
	return `${s4()}${s4()}.${s4()}.${s4()}.${s4()}.${s4()}${s4()}${s4()}`;
}



const utils = {
	setCookie,
	getCookie,
	clearCookie,
	hasCookie,
	guid
}

export default utils;